import React, { useState } from "react"
import Lightbox from "yet-another-react-lightbox"
import i18n from "@/i18n"
import ImagePreview from "./image_preview"
import type { VenueImageGalleryProps } from "./types"
import { isVenuePhotoWithUrl } from "./types"

const STYLES = {
  emptyContainer: "w-full h-60 bg-gray-200 flex items-center justify-center",
  emptyText: "text-gray-400 text-lg",
  singleImage: "w-full h-60",
} as const

const VenueImageGalleryMobile: React.FC<VenueImageGalleryProps> = ({ images }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [lightboxIndex, setLightboxIndex] = useState(0)
  const venuePhotos = images.filter(isVenuePhotoWithUrl)

  const handleImageClick = (index: number) => {
    setLightboxIndex(index)
    setLightboxOpen(true)
  }

  if (venuePhotos.length === 0) {
    return (
      <div className={STYLES.emptyContainer} data-testid="public-venue-gallery-empty">
        <span className={STYLES.emptyText}>{i18n.t("app.public.venue.gallery.empty_state")}</span>
      </div>
    )
  }

  return (
    <div data-testid="public-venue-gallery-container">
      <ImagePreview photo={venuePhotos[0]} index={0} onImageClick={handleImageClick} className={STYLES.singleImage} />
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        index={lightboxIndex}
        slides={venuePhotos.map((photo) => ({ src: photo.url }))}
        carousel={{ padding: "16px" }}
      />
    </div>
  )
}

export default VenueImageGalleryMobile
